<template>
  <header class="header-simple">
    <div class="header-simple__logo-container">
      <a href="/" class="header-simple__logo" aria-label="Home">
        <header-logo />
      </a>
    </div>
  </header>
</template>

<script>
import HeaderLogo from './header-logo/HeaderLogo.vue'

export default {
  name: 'HeaderSimple',
  components: {
    HeaderLogo,
  },
}
</script>

<style lang="scss">
.header-simple {
  box-shadow: 0 1px 0 0 #f1f4f8;
  background-color: white;

  &__logo-container {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__logo {
    display: inline-block;
  }
}

@media (min-width: $screen_large) {
  .header-simple {
    &__logo-container {
      position: relative;
      height: 65px;
    }
  }
}
</style>
